import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_348: DocMigration = {
  maxSchemaVersion: "0.0.348",
  description: "Remove 'addToMechanicalPlan' and 'addToPlumbingPlan' built in entity tags and all references",
  apply(json: any) {
    // delete from doc table
    deleteTagProps(json.entityTags);

    // delete references from entities
    deleteTagReferencesFromTableBasedEntity(json.annotation);
    deleteTagReferencesFromTableBasedEntity(json.props);
    deleteTagReferencesFromTableBasedEntity(json.ceilings);
    deleteTagReferencesFromTableBasedEntity(json.sheets);
    deleteTagReferencesFromTableBasedEntity(json.viewTemplateOverrides);

    for (const id in json.planViews) {
      const planView = json.planViews[id];
      deleteTagProps(planView.viewFilter.tags);
    }

    for (const id in json.settings) {
      const settings = json.settings[id];
      if (settings.type === "ANNOTATION_CATALOG_SETTINGS") {
        for (const templateId in settings.annotationTemplates) {
          const template = settings.annotationTemplates[templateId];
          deleteTagProps(template.tags);
        }
      }
    }

    return json;
  },
};

export default migration_0_0_348;

function deleteTagProps(tagsTable: any = {}) {
  delete tagsTable.addToMechanicalPlan;
  delete tagsTable.addToPlumbingPlan;
}

function deleteTagReferencesFromTableBasedEntity(table: any) {
  for (const id in table) {
    const entity = table[id];
    deleteTagProps(entity.tags);
  }
}
